export const name = '_1inch'
export const ticker = `${name}_1INCH`
export const displayName = '1inch'
export const displayTicker = '1INCH'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 18,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = ['oneinch', '1inch_bsc_61c44543']
